// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__CkCGp","loaderOuter":"PageOverlayLoader_loaderOuter__2UEZY"};